// extracted by mini-css-extract-plugin
module.exports = {"identifier":"otp_identifier__1UVeD","disabled":"otp_disabled__3qhm0"};